module.exports = "<input name=file type=file custom-on-change=uploadFile ng-required=\"{{ required }}\"/> ";


//////////////////
// WEBPACK FOOTER
// ./app/common/directives/file-upload.html
// module id = 526
// module chunks = 0